import { defineComponent as _defineComponent } from 'vue'
import { TheUserDropdown, useTimezoneTime } from '@maropost-ui/liquidsky-ui'
import { useUserStore } from '@/lib/stores'
import useUserDropdownMenu from '@/lib/composable/usermenu/userDropdownMenu'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserDropDown',
  props: {
    timezone: { type: String, required: false, default: 'UTC' }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props
const { displayTime } = useTimezoneTime(props.timezone)


/* --------------------------------------------------
 * Store
 * --------------------------------------------------
 */
const userStore = useUserStore()

/* --------------------------------------------------
 * Reactive Menu (AUTO-UPDATES ON ACCESS CHANGE)
 * --------------------------------------------------
 */
const userItems = useUserDropdownMenu()

const __returned__ = { props, displayTime, userStore, userItems, get TheUserDropdown() { return TheUserDropdown } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})